import { render, staticRenderFns } from "./PaypalSuccessPageComponent.vue?vue&type=template&id=2e541c4c&scoped=true&"
import script from "./PaypalSuccessPageComponent.vue?vue&type=script&lang=js&"
export * from "./PaypalSuccessPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./PaypalSuccessPageComponent.vue?vue&type=style&index=0&id=2e541c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e541c4c",
  null
  
)

export default component.exports